import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__title" }
const _hoisted_3 = { class: "top-chart" }
const _hoisted_4 = { class: "top-chart__label" }
const _hoisted_5 = { class: "top-chart__bar-wrapper" }
const _hoisted_6 = { class: "top-chart__percent" }
const _hoisted_7 = { class: "top-chart__value" }

import {computed} from "vue";
import {getRegionName} from "@/composables/functions/getRegionName";
import IconArrowDown from "@/assets/icons/IconArrowDown.vue";
import {Region} from "@/types/files";
import {RegionTopProps} from "@/types/analytics";
import {getDistrictName} from "@/composables/functions/getDistrictName";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegionTop',
  props: {
    activeType: {},
    selectedDistrict: {},
    sortOrder: { default: "desc" },
    regionList: {}
  },
  setup(__props: any) {

const props = __props;

// Сортируем данные и находим максимальное значение
const sortedData = computed(() => {
  if (!props.regionList) return [];

  const dataArray = Object.entries(props.regionList).map(([key, data]) => ({
    key: key as Region,
    value: data?.value ?? 0,
    percent: data?.percent ?? 0
  }));

  return dataArray.sort((a, b) => {
    return props.sortOrder === "desc"
        ? b.value - a.value
        : a.value - b.value;
  });
});

// Находим максимальное значение для расчета ширины баров
const maxValue = computed(() => {
  return Math.max(...sortedData.value.map(item => item.value));
});

// Функция для расчета ширины бара в процентах
const getBarWidth = (value: number) => {
  const percentage = (value / maxValue.value) * 100;
  return `${percentage}%`;
};

// Проверка положительного значения процента
const isPositivePercent = (percent: number) => {
  return percent > 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      (__props.activeType === 'russia')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Топ-10 регионов с " + _toDisplayString(__props.sortOrder === "desc" ? 'наибольшими' : 'наименьшими') + " показателями ", 1)
          ], 64))
        : (__props.activeType === 'district')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Топ регионов по " + _toDisplayString(_unref(getDistrictName)(__props.selectedDistrict)) + " с " + _toDisplayString(__props.sortOrder === "desc" ? 'наибольшими' : 'наименьшими') + " показателями ", 1)
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.key,
          class: "top-chart__item"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getRegionName)(item.key)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["top-chart__bar", { 'top-chart__bar--positive': isPositivePercent(item.percent) }]),
              style: _normalizeStyle({ width: getBarWidth(item.value) })
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(IconArrowDown, {
                  class: _normalizeClass(["top-chart__icon", {'top-chart__icon--positive': isPositivePercent(item.percent)}])
                }, null, 8, ["class"]),
                _createTextVNode(" " + _toDisplayString(item.percent) + "% ", 1)
              ])
            ], 6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.value), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})